import Cookies from "js-cookie";
import {
  CREATE_MATERIAL_COURSE_FOLDER_URL,
  CREATE_MATERIAL_SUBJECT_FOLDER_URL,
  CREATE_MATERIAL_TOPIC_FOLDER_URL,
  CREATE_MATERIAL_SUBTOPIC_FOLDER_URL,
  GET_MATERIAL_FOLDER_URL,
  UPDATE_MATERIAL_FOLDER_URL,
  DELETE_MATERIAL_FOLDER_URL,
  CREATE_MATERIAL_URL,
  DELETE_MATERIAL_URL,
  GET_MATERIALS_URL,
  GET_MATERIALS_BY_TITLE_KEY_URL,
  GET_MATERIAL_URL,
  UPDATE_MATERIAL_URL,
  PDF_TO_MARKDOWN_CONVERT_URL,
} from "../apiurls/apiurls";

const getAuthToken = () => {
  return Cookies.get("admin_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const createMaterialCourseFolder = async (title, key, name) => {
  const response = await fetch(CREATE_MATERIAL_COURSE_FOLDER_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ title, key, name }),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const getMaterialsByFolder = async (folderId) => {
  const params = new URLSearchParams();
  if (folderId) params.append("materials_folders", folderId);

  const response = await fetch(`${GET_MATERIALS_URL}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const createMaterialSubjectFolder = async (title, key, name) => {
  const response = await fetch(CREATE_MATERIAL_SUBJECT_FOLDER_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ title, key, name }),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const createMaterialTopicFolder = async (title, key, name) => {
  const response = await fetch(CREATE_MATERIAL_TOPIC_FOLDER_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ title, key, name }),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const createMaterialSubtopicFolder = async (title, key, name) => {
  const response = await fetch(CREATE_MATERIAL_SUBTOPIC_FOLDER_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ title, key, name }),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const getMaterialFolders = async (title, key) => {
  const params = new URLSearchParams();
  if (title) params.append("title", title);
  if (key) params.append("key", key);

  const response = await fetch(
    `${GET_MATERIAL_FOLDER_URL}?${params.toString()}`,
    {
      method: "GET",
      headers: getHeaders(),
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const updateMaterialFolder = async (id, name) => {
  if (!id) throw new Error("Folder id is required for update");
  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(
    `${UPDATE_MATERIAL_FOLDER_URL}?${params.toString()}`,
    {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify({ name }),
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const deleteMaterialFolder = async (id) => {
  if (!id) throw new Error("Folder id is required for delete");
  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(
    `${DELETE_MATERIAL_FOLDER_URL}?${params.toString()}`,
    {
      method: "DELETE",
      headers: getHeaders(),
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const createMaterial = async (payload, file = null) => {
  if (file) {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (key !== "content") {
        formData.append(key, payload[key]);
      }
    });

    formData.append("file", file);

    const response = await fetch(CREATE_MATERIAL_URL, {
      method: "POST",
      headers: {
        ...getHeadersWithoutContentType(),
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } else {
    const response = await fetch(CREATE_MATERIAL_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }
};

export const getMaterialsByTitleKey = async ({ title, key } = {}) => {
  if (!title || !key) {
    throw new Error("title and key are required");
  }

  const params = new URLSearchParams();
  params.append("title", title);
  params.append("key", key);

  const response = await fetch(
    `${GET_MATERIALS_BY_TITLE_KEY_URL}?${params.toString()}`,
    {
      method: "GET",
      headers: getHeaders(),
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const convertPdfToMarkdown = async (file, options = {}) => {
  if (!file) throw new Error("PDF file is required");

  const token = getAuthToken();
  if (!token) throw new Error("Token is required");

  const pdfBase64 = await fileToBase64(file);

  const materialId = options?.materialId || options?.material_id || null;

  return convertPdfToMarkdownViaSocket(
    {
      pdf: pdfBase64,
      token,
      ...(materialId ? { material_id: materialId } : {}),
    },
    options,
  );
};

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Failed to read PDF file"));
    reader.onload = () => {
      const res = reader.result;
      if (typeof res !== "string") {
        reject(new Error("Failed to read PDF file"));
        return;
      }
      const commaIndex = res.indexOf(",");
      resolve(commaIndex >= 0 ? res.slice(commaIndex + 1) : res);
    };
    reader.readAsDataURL(file);
  });
};

const toWebSocketUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("ws://") || url.startsWith("wss://")) return url;
  if (url.startsWith("https://")) return `wss://${url.slice("https://".length)}`;
  if (url.startsWith("http://")) return `ws://${url.slice("http://".length)}`;
  return url;
};

const convertPdfToMarkdownViaSocket = (payload, options = {}) => {
  return new Promise((resolve, reject) => {
    let ws;
    let settled = false;
    const pages = new Map();
    let lastProgressMsg = null;
    let totalPages = 0;
    const onProgress = typeof options?.onProgress === "function" ? options.onProgress : null;
    const onSocket = typeof options?.onSocket === "function" ? options.onSocket : null;
    const isCancelled = typeof options?.isCancelled === "function" ? options.isCancelled : null;

    const settle = (fn, value) => {
      if (settled) return;
      settled = true;
      try {
        if (ws && ws.readyState === WebSocket.OPEN) ws.close();
      } catch (_) {}
      fn(value);
    };

    const timeoutMs = Number(options?.timeoutMs);
    const hasTimeout = Number.isFinite(timeoutMs) && timeoutMs > 0;
    const timer = hasTimeout
      ? setTimeout(() => {
          settle(reject, new Error("PDF conversion timed out"));
        }, timeoutMs)
      : null;

    try {
      const wsUrl = toWebSocketUrl(PDF_TO_MARKDOWN_CONVERT_URL);
      ws = new WebSocket(wsUrl);
      if (onSocket) onSocket(ws);
    } catch (e) {
      if (timer) clearTimeout(timer);
      settle(reject, new Error("Failed to open PDF conversion socket"));
      return;
    }

    ws.onerror = () => {
      if (timer) clearTimeout(timer);
      settle(reject, new Error("PDF conversion socket error"));
    };

    ws.onopen = () => {
      try {
        ws.send(JSON.stringify(payload));
      } catch (e) {
        if (timer) clearTimeout(timer);
        settle(reject, new Error("Failed to send PDF payload"));
      }
    };

    ws.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        lastProgressMsg = msg;

        if (msg?.status === "started") {
          totalPages = Number(msg?.total_pages) || 0;
          if (onProgress) {
            onProgress({
              status: "started",
              total_pages: totalPages,
            });
          }
          return;
        }

        if (msg?.error || msg?.message === "error") {
          if (timer) clearTimeout(timer);
          settle(reject, new Error(String(msg.error || msg.data || "Conversion failed")));
          return;
        }

        if (typeof msg?.page === "number" && typeof msg?.markdown === "string") {
          pages.set(msg.page, msg.markdown);
          if (onProgress) {
            onProgress({
              status: "processing",
              page: msg.page,
              total_pages: totalPages,
              markdown: msg.markdown,
            });
          }
          return;
        }

        if (Array.isArray(msg?.markdown)) {
          const extractedPages = [];
          msg.markdown.forEach((item) => {
            const p = Number(item?.page);
            const md = item?.markdown;
            if (Number.isFinite(p) && p > 0 && typeof md === "string") {
              pages.set(p, md);
              extractedPages.push([p, md]);
            }
          });

          if (onProgress && msg?.status === "completed" && extractedPages.length > 0) {
            extractedPages
              .sort((a, b) => a[0] - b[0])
              .forEach(([pageNo, md]) => {
                onProgress({
                  status: "processing",
                  page: pageNo,
                  total_pages: Number(msg?.total_pages) || totalPages,
                  markdown: md,
                });
              });
          }
        }

        if (msg?.markdown || msg?.data?.markdown) {
          const md = msg?.markdown ?? msg?.data?.markdown;
          if (typeof md === "string") {
            pages.set(1, md);
          }
        }

        if (msg?.status === "completed") {
          if (timer) clearTimeout(timer);
          if (!totalPages) {
            totalPages = Number(msg?.total_pages) || totalPages;
          }
          const combined = Array.from(pages.entries())
            .sort((a, b) => a[0] - b[0])
            .map(([, md]) => md)
            .filter(Boolean)
            .join("\n\n");

          if (onProgress) {
            onProgress({
              status: "completed",
              total_pages: totalPages,
            });
          }

          settle(resolve, combined ? { markdown: combined } : lastProgressMsg || msg);
        }
      } catch (e) {
        if (timer) clearTimeout(timer);
        settle(reject, new Error("Invalid response from PDF conversion socket"));
      }
    };

    ws.onclose = () => {
      if (timer) clearTimeout(timer);
      if (!settled) {
        if (isCancelled && isCancelled()) {
          settle(reject, new Error("PDF conversion cancelled"));
          return;
        }
        settle(reject, new Error("PDF conversion socket closed unexpectedly"));
      }
    };
  });
};

export const getMaterials = async (paramsObj = {}) => {
  try {
    const params = new URLSearchParams();
    Object.entries(paramsObj).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") {
        params.append(k, v);
      }
    });

    const response = await fetch(`${GET_MATERIALS_URL}?${params.toString()}`, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data && Array.isArray(data.data)) {
      return data.data;
    }
    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Failed to fetch materials", error);
    throw error;
  }
};

export const getMaterialById = async (id) => {
  const params = new URLSearchParams();
  if (id) params.append("id", id);

  const response = await fetch(`${GET_MATERIAL_URL}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const updateMaterial = async (id, payload, file = null) => {
  if (!id) throw new Error("Material id is required for update");
  const params = new URLSearchParams();
  params.append("id", id);

  if (file) {
    const formData = new FormData();

    Object.keys(payload || {}).forEach((key) => {
      if (key !== "content") {
        formData.append(key, payload[key]);
      }
    });

    formData.append("file", file);

    const response = await fetch(
      `${UPDATE_MATERIAL_URL}?${params.toString()}`,
      {
        method: "PUT",
        headers: {
          ...getHeadersWithoutContentType(),
        },
        body: formData,
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  const response = await fetch(`${UPDATE_MATERIAL_URL}?${params.toString()}`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const deleteMaterial = async (id) => {
  if (!id) throw new Error("Material id is required for delete");
  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${DELETE_MATERIAL_URL}?${params.toString()}`, {
    method: "DELETE",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

const getHeadersWithoutContentType = () => {
  const token = getAuthToken();
  if (token) {
    return { Authorization: ` ${token}` };
  }
  return {};
};
